import {useAppContext} from "./useAppContext";

export const useWriteReviewButtonModel = () => {
    const {productId} = useAppContext();
    return {href: `/review/write/${productId}`};
}